import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { mapResourceToFormValues } from "../contactFilter/mappers";
import { ContactFilterUpdateResource } from "../shared/types";

interface Props {
	filter: ContactFilterUpdateResource | null;
}
export const PredefinedFilterApplier: FC<Props> = ({ filter }) => {
	const { setValues } = useFormikContext();

	useEffect(() => {
		if (filter) {
			void setValues(mapResourceToFormValues(filter));
		}
	}, [filter, setValues]);

	return null;
};
